import { EntityActions, OrganizationActions } from '../actions/consts';

type OrganizationsUIState = {
  loading: boolean;
  errorMessage: string;
  currentList: [];
  currentPage: number;
}

type OrganizationsState = {
  entities: {};
  ui: OrganizationsUIState;
}

export function organizations(
  state = { entities: {}, ui: { currentList: [], currentPage: 0, loading: false, errorMessage: '' } } as OrganizationsState, action
) {
  switch (action.type) {
    case EntityActions.ADD_ENTITIES:
      return {
        ...state,
        entities: {
          ...state.entities,
          ...action.entities.organizations,
        }
      };
    case OrganizationActions.LOAD_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: true,
          errorMessage: '',
        }
      };
    case OrganizationActions.LOAD_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
        }
      };
    case OrganizationActions.LOAD_ERROR:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: action.error.errorMessage,
        }
      };
    case OrganizationActions.LOAD_LIST_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
          currentList: action.result,
        }
      };
    case OrganizationActions.SET_CURRENT_PAGE:
      return {
        ...state,
        ui: {
          ...state.ui,
          currentPage: action.currentPage,
        }
      };
    default:
      return state;
  }
}
